$(document).ready(function(){
     var length = $('.thumbnail-list__item ').length;
    // alert(length);
    if(length > 1){
      $('.left').show();
       $('.right').show();
    }
    else{
       $('.left').hide();
       $('.right').hide();
    }
     $(".grid__item.product__media-wrapper button.right").click(function() {
  console.log(4564);
      
   var btnn = $('.thumbnail-list .thumbnail-list__item button.thumbnail[aria-current="true"]')
  btnn.closest('li.thumbnail-list__item').next().find('button.thumbnail').click();
});

   $(".grid__item.product__media-wrapper button.left").click(function() {
  console.log(4564);
   var btnn = $('.thumbnail-list .thumbnail-list__item button.thumbnail[aria-current="true"]')
  btnn.closest('li.thumbnail-list__item').prev().find('button.thumbnail').click();
});
  })
 